import React from 'react'
import PropTypes from 'prop-types'

/* Components */
import Slider from '../slider'
import {GenericModal} from '../../hooks/use-generic-modal'

/* Hooks */
import {useBreakpointValue} from '@chakra-ui/react'

/**
 * SliderModal component - used to display a slider in a modal
 * @param {Object} props
 * @param {React.ReactNode} props.children
 * @param {boolean} props.isOpen
 * @param {function} props.onClose
 * @returns {React.ReactElement}
 * @constructor
 * @see https://chakra-ui.com/docs/overlay/modal
 * @example
 * <SliderModal isOpen={isOpen} onClose={onClose}>
 *    {items.map(i => <Box>{i}</Box>)}
 * </SliderModal>
 */
const SliderModal = ({
    children,
    isOpen,
    onClose,
    colorScheme = 'stokkeCore',
    size = 'lg',
    variant = 'bonusOffer',
    ...props
}) => {
    const isCentered = useBreakpointValue({base: false, sm: true})

    /* If there are no children (slides), don't show component at all */
    if (!children) return null

    return (
        <GenericModal
            isOpen={isOpen}
            onClose={onClose}
            isCentered={isCentered}
            size={size}
            colorScheme={colorScheme}
            variant={variant}
            {...props}
        >
            <Slider variant="modal" {...props}>
                {children?.map((child) => child)}
            </Slider>
        </GenericModal>
    )
}

SliderModal.propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    variant: PropTypes.string,
    colorScheme: PropTypes.string,
    size: PropTypes.string
}

export default SliderModal
